import React, { PureComponent } from 'react';
import * as api from '../../../../services/api';
import RenewalProductListPage from '../../../presenters/renewals/RenewalProductListPage/RenewalProductListPage';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actions from '../../../../actions';
import { POPUPS } from './constants';
import * as RenewalStatus from '../../../../constants/RenewalStatus';
import * as WorkFlowAction from '../../../../constants/WorkFlowAction';
import ConfirmationDialogPresenter from '../../../presenters/renewals/ConfirmationDialogPresenter/ConfirmationDialogPresenter';
import { Snackbar } from '@material-ui/core';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import {
  getRenewalValidations,
  isRenewalMutable
} from '../../../../utils/renewals-util';
import { RENEWALS_PORTAL_URL } from '../../../../route-names';
import { injectIntl } from 'react-intl';
import {
  APPROVAL_LEVELS,
  APPROVAL_LEVELS_MAPPING,
  APPROVAL_LEVELS_ORDINAL
} from '../../../../utils/util-constants';
import { cloneDeep } from 'lodash';
import { isNullOrEmpty } from '../../../../utils/utils';
import { showPdf } from '../../../../utils/file-util';

class RenewalPageWrapper extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      renewal: null,
      customer: null,
      confirmationPopup: null,
      employeeApprovalTier: null,
      renewalApprovalTier: null,
      apiResponse: null,
      appConfigs: this.props.appStore.appConfigs
    };

    this.branchRouteCustomerId = props.match.params.branchRouteCustomerId;

    this.loadInitialState = this.loadInitialState.bind(this);
    this.updateRenewal = this.updateRenewal.bind(this);
    this.handleStartRenewal = this.handleStartRenewal.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.handleSubmitRenewal = this.handleSubmitRenewal.bind(this);
    this.getConfirmPopupHandler = this.getConfirmPopupHandler.bind(this);
    this.handleCloseSnackbar = this.handleCloseSnackbar.bind(this);
    this.handleClickCloseRenewal = this.handleClickCloseRenewal.bind(this);
    this.handleCloseRenewal = this.handleCloseRenewal.bind(this);
    this.canAdvanceRenewal = this.canAdvanceRenewal.bind(this);
    this.isApprovalRequired = this.isApprovalRequired.bind(this);
    this.getRenewalApproverTier = this.getRenewalApprovalTier.bind(this);
    this.handleBasePriceIncrease = this.handleBasePriceIncrease.bind(this);
    this.handleGenerateProposal = this.handleGenerateProposal.bind(this);
    this.handleCreateAgreement = this.handleCreateAgreement.bind(this);
    this.canPropose = this.canPropose.bind(this);
  }

  componentDidMount() {
    this.loadInitialState();
  }

  loadInitialState() {
    const [branchId, routeNumber, customerId] =
      this.branchRouteCustomerId.split(':');

    const renewalPromise = api.renewals.search(undefined, {
      customerIds: [customerId]
    });

    const customerPromise = renewalPromise.then((renewalResponse) => {
      if (renewalResponse.data.content.length > 1) {
        throw Error('multiple renewals for customer');
      }
      return api.customers.getOne(branchId, routeNumber, customerId);
    });

    const routeApprovalPromise = api.routeApproval.getRouteApprovalTier(
      branchId,
      routeNumber
    );

    Promise.all([renewalPromise, customerPromise, routeApprovalPromise])
      .then(([renewalResponse, customerResponse, routeApprovalReponse]) => {
        const customer = customerResponse.data;
        const renewal = renewalResponse.data.content[0];
        const employeeApprovalTier = routeApprovalReponse.data;


        let renewalApprovalTier = APPROVAL_LEVELS.NONE;

        if (!!renewal && !!renewal.lineItems) {
          renewalApprovalTier = this.getRenewalApprovalTier(renewal);
        }
        this.setState({
          customer,
          renewal,
          employeeApprovalTier,
          renewalApprovalTier,
          loading: false
        });
      })
      .catch((error) => {
        throw Error('unable to download renewal');
      });
  }

  getRenewalApprovalTier(renewal) {
    let renewalApprovalTier = APPROVAL_LEVELS.NONE;

// mark validation fields for line items
    renewal.validationErrors.forEach((validationError) => {
      const id = validationError.lineItemId;
      const field = validationError.validationField;

      const lineItem = renewal.lineItems.find(
        (lineItem) => lineItem.lineItemId === id
      );

      if (lineItem) {
        if (!lineItem.validationFields) {
          lineItem.validationFields = [];
        }
        lineItem.validationFields.push(field.toUpperCase());
        lineItem.requiresApproval = true;
      }
    });

    if (
      renewal.validationErrors.some(
        (validationError) =>
          validationError.validityLevel === APPROVAL_LEVELS.TIER3_APPROVAL
      )
    ) {
      renewalApprovalTier = APPROVAL_LEVELS.TIER3_APPROVAL;
    } else if (
      renewal.validationErrors.some(
        (validationError) =>
          validationError.validityLevel === APPROVAL_LEVELS.TIER2_APPROVAL
      )
    ) {
      renewalApprovalTier = APPROVAL_LEVELS.TIER2_APPROVAL;
    } else if (
      renewal.validationErrors.some(
        (validationError) =>
          validationError.validityLevel === APPROVAL_LEVELS.TIER1_APPROVAL
      )
    ) {
      renewalApprovalTier = APPROVAL_LEVELS.TIER1_APPROVAL;
    }

    return renewalApprovalTier;
  }
  handleCloseSnackbar() {
    this.setState({
      apiResponse: null
    });
  }

  updateRenewal(updatedRenewal, submitUpdates = true) {
    if (submitUpdates) {
      this.setState(
        { loading: true },
        () =>    api.renewals
            .update(updatedRenewal)
            .then((response) =>
              this.setState(
                {
                  apiResponse: this.props.intl.formatMessage({
                    id: 'renewal_updated'
                  })
                },
                () => {
                  this.loadInitialState();
                }
              )
            )
            .catch((error) => {
              console.error(error);
              this.setState({
                loading: false,
                apiResponse: this.props.intl.formatMessage({
                  id: 'error_updating_renewal'
                })
              });
            })
    );
    } else {
      this.setState({ renewal: updatedRenewal });
    }
  }

  async handleStartRenewal() {
    this.setState(
      {
        loading: true
      });

    const [branchId, routeNumber, customerId] =
      this.state.customer.branchRouteCustomerId.split(':');

    try {
      const response = await api.renewals.startByBrc(this.state.customer.branchRouteCustomerId);
      const newRenewal = response.data;
      const newApprovalTier = this.getRenewalApprovalTier(newRenewal);

      const customerResponse = await api.customers.getOne(branchId, routeNumber, customerId);

      this.setState({
        renewal: newRenewal,
        renewalApprovalTier: newApprovalTier,
        customer: customerResponse.data,
        apiResponse: this.props.intl.formatMessage({ id: 'renewal_created' }),
        loading: false
      });

    }
    catch (error) {
      console.error('Error creating renewal.', error);

      if (error.response?.status === 500) {
        try {
          const checkResponse = await api.renewals.search(undefined, {
            customerIds: [this.state.customer.customerId]
          });

          const existingRenewal = checkResponse.data?.content?.[0];
          if (existingRenewal) {
            const newApprovalTier = this.getRenewalApprovalTier(existingRenewal);

            const customerResponse = await api.customers.getOne(branchId, routeNumber, customerId);

            this.setState({
              renewal: existingRenewal,
              renewalApprovalTier: newApprovalTier,
              customer: customerResponse.data,
              apiResponse: this.props.intl.formatMessage({ id: 'renewal_created' }),
              loading: false
            });
            return;
          }
        } catch (checkErr) {
          console.error('Fallback check failed after 500.', checkErr);
        }
      }

      this.setState({
        apiResponse: this.props.intl.formatMessage({ id: 'error_creating_renewal' }),
        loading: false
      });
    }
  }

  getConfirmPopupHandler() {
    switch (this.state.confirmationPopup) {
      case POPUPS.APPROVAL_REQUIRED:
        return () => this.handleSubmitRenewal(WorkFlowAction.SEND_TO_APPROVER);
      case POPUPS.AUTO_APPROVAL:
        const hasCustomerEmail = !isNullOrEmpty(
          this.state.renewal.customerEmail
        );
        return () =>
          this.handleSubmitRenewal(
            hasCustomerEmail
              ? WorkFlowAction.APPROVE_AND_SEND_TO_CUSTOMER
              : WorkFlowAction.APPROVE
          );
      case POPUPS.CLOSE:
        return this.handleCloseRenewal;
      case POPUPS.CREATEAGREEMENT:
        return () =>
        this.handleGenerateProposal(this.state.renewal);
      default:
        return null;
    }
  }

  handleSubmitRenewal(workflowAction) {
    const { employeeApprovalTier, renewalApprovalTier } = this.state;
    this.closePopup();

    this.setState(
      { loading: true },
      () => {
        api.renewals
          .update(this.state.renewal)
          .then(() => {
            return api.renewals.submit(
              this.state.renewal.renewalId,
              workflowAction
            );
          })
          .then((response) => {
            this.setState({
              apiResponse: this.props.intl.formatMessage({
                id: 'renewal_sent_forward'
              })
            });

            this.props.history.push(RENEWALS_PORTAL_URL);
          })
          .catch((error) => {
            console.error('Error sending renewal forward.', error);
            console.error('full error:', JSON.stringify(error, null, 2));

            this.setState({
              apiResponse: this.props.intl.formatMessage({
                id: 'error_sending_renwal_forward'
              })
            });
          })
          .then(this.loadInitialState);
      }
    );
  }

  isApprovalRequired(validityResponses) {
    if (!!validityResponses || validityResponses.length === 0) {
      return false;
    }
    return validityResponses.some(
      (response) =>
        response.validityLevel === APPROVAL_LEVELS.TIER3_APPROVAL ||
        response.validityLevel === APPROVAL_LEVELS.TIER2_APPROVAL ||
        response.validityLevel === APPROVAL_LEVELS.TIER1_APPROVAL
    );
  }

  handleClickCloseRenewal() {
    this.setState({
      confirmationPopup: POPUPS.CLOSE
    });
  }

  handleCloseRenewal() {
    this.closePopup();
    this.setState(
      {
        loading: true
      },
      () => {
        api.renewals
          .update(this.state.renewal)
          .then(() => {
            return api.renewals.submit(
              this.state.renewal.renewalId,
              WorkFlowAction.DELETE
            );
          })
          .then((response) => {
            this.setState({
              apiResponse: this.props.intl.formatMessage({
                id: 'renewal_closed'
              })
            });
          })
          .catch((error) => {
            this.setState({
              apiResponse: this.props.intl.formatMessage({
                id: 'error_closing_renewal'
              })
            });
          })
          .then(this.loadInitialState);
      }
    );
  }

  async handleCreateAgreement(renewal) {
    this.setState({
      confirmationPopup: POPUPS.CREATEAGREEMENT
    });

  }



  /*
              Can advance renewal if:
                * Is in progress
                * Is in Approval Required and employee has equivalent current approval tier
            */
  canAdvanceRenewal() {
    const { renewal, employeeApprovalTier, customer } = this.state;
    return (
      renewal &&
      (renewal.status === RenewalStatus.IN_PROGRESS.name ||
        (renewal.status === RenewalStatus.APPROVAL_REQUIRED.name &&
          (employeeApprovalTier.includes(customer?.workflowTicket?.currentApprovalTier))))
    );
  }

  canPropose() {
    const { renewal, customer } = this.state;
    return (
      renewal &&
      (renewal.status === RenewalStatus.IN_PROGRESS.name ||
        (renewal.status === RenewalStatus.APPROVAL_REQUIRED.name &&
          customer?.workflowTicket?.currentApprovalTier === APPROVAL_LEVELS.NONE))
    );
  }

  /**
   * The next button will do one of two things:
   *
   * If the renewal requires approval (determined by hitting /renewals/validate) it will
   * pop up the modal that shows why it needs approval, from which the user can then send
   * forward for approval.
   *
   * If the renewal does not require approval, it will pop up the modal that asks the
   * user to confirm the submission for auto-approval.
   */
  handleNext() {
    const { employeeApprovalTier, renewalApprovalTier, customer } = this.state;

    let remainingApprovalTiers = '';
    for (let i = APPROVAL_LEVELS_ORDINAL[renewalApprovalTier]; i >= APPROVAL_LEVELS_ORDINAL[APPROVAL_LEVELS_MAPPING[customer?.workflowTicket?.currentApprovalTier]]; i--) {
      const approvalOrdinal = this.getEnumKeyByValue(APPROVAL_LEVELS_ORDINAL,i);
      const approvalTier = this.getEnumKeyByValue(APPROVAL_LEVELS_MAPPING,approvalOrdinal);
      remainingApprovalTiers = remainingApprovalTiers.concat(approvalTier);
    }

    const confirmationPopup =
      employeeApprovalTier.includes(remainingApprovalTiers)
        ? POPUPS.AUTO_APPROVAL
        : POPUPS.APPROVAL_REQUIRED;

    this.setState({
      confirmationPopup
    });
  }

  getEnumKeyByValue(enumObj, value) {
    return Object.keys(enumObj).find(key => enumObj[key] === value);
  }

  handleBasePriceIncrease(basePrice) {
    const customerKey = this.state.customer.branchRouteCustomerId;

    this.setState(
      {
        loading: true
      },
      () =>
        api.customers
          .patchCustomerBasePrice(customerKey, basePrice)
          .then((response) =>
            this.setState({
              customer: response.data
            })
          )
          .catch((error) => {
            this.setState({
              apiResponse: this.props.intl.formatMessage({
                id: 'error_updating_renewal_base_price'
              })
            });
          })
          .then(() =>
            this.setState({
              loading: false
            })
          )
    );
  }

  closePopup(discardCustomerInfo = false) {
    if (discardCustomerInfo) {
      this.setState({
        confirmationPopup: null,
        renewal: {
          ...cloneDeep(this.state.renewal),
          customerApproverName: '',
          customerEmail: ''
        }
      });
    } else {
      this.setState({
        confirmationPopup: null
      });
    }
  }

  async handleGenerateProposal(renewal) {

    try {
      const responses = await api.renewals.getRenewalProposal(
        renewal.renewalId
      );

      showPdf(
        responses.data,
        `${
          renewal.deliverToCustomerName
            ? renewal.deliverToCustomerName
            : renewal.customerName
        }_proposal`
      );
    } catch (error) {
      this.setState({
        message: this.props.intl.formatMessage({ id: 'pdf_error_message' })
      });
    }

    this.closePopup();
    this.setState(
      {
        loading: true
      },
      () => {
        api.renewals
          .submit(this.state.renewal.renewalId, WorkFlowAction.DELETE)
          .then((response) => {
            this.setState({
              apiResponse: this.props.intl.formatMessage({
                id: 'renewal_closed'
              })
            });
          })
          .catch((error) => {
            this.setState({
              apiResponse: this.props.intl.formatMessage({
                id: 'error_closing_renewal'
              })
            });
          })
          .then(this.loadInitialState);
      }
    );
  }

  render() {
    return !this.state.loading ? (
      <div>
        <RenewalProductListPage
          appConfigs={this.state.appConfigs}
          renewal={this.state.renewal}
          customer={this.state.customer}
          employeeApprovalTier = {this.state.employeeApprovalTier}
          disabled={
            !isRenewalMutable(
              this.state.renewal,
              this.state.customer.branchCode
            )
          }
          onUpdateRenewal={this.updateRenewal}
          onNext={this.handleNext}
          canAdvanceRenewal={this.canAdvanceRenewal}
          handleStartRenewal={this.handleStartRenewal}
          handleCloseRenewal={this.handleClickCloseRenewal}
          handleBasePriceIncrease={this.handleBasePriceIncrease}
          priceReasonCodes={this.props.appStore.priceReasonCodes}
          handleGenerateProposal={this.handleGenerateProposal}
          handleCreateAgreement={this.handleCreateAgreement}
          canPropose={this.canPropose}
        />
        <ConfirmationDialogPresenter
          popup={this.state.confirmationPopup}
          onAccept={this.getConfirmPopupHandler()}
          onClose={this.closePopup}
          popupData={{
            validations: !!this.state.renewal
              ? getRenewalValidations(
                  this.state.renewal,
                  this.props.appStore.priceReasonCodes,
                  this.props.intl
                )
              : [],
            customer: this.state.customer,
            renewal: this.state.renewal,
            updateRenewal: this.updateRenewal
          }}
        />
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          open={!!this.state.apiResponse}
          onClose={this.handleCloseSnackbar}
          message={<span id="message-id">{this.state.apiResponse}</span>}
        />
      </div>
    ) : (
      <LoadingWidget />
    );
  }
}

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch)
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(RenewalPageWrapper))
);
